// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell_cell__pc8jm","cell2":"cell_cell2__tBopB","cell3":"cell_cell3__tAtfV"};